var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Story',{attrs:{"title":"๑. จกฺขุปาลตฺเถรวตฺถุ.","pak":"1","wak":"1","story":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }